export default __webpack_public_path__ + "static/media/user_activity_45.10e29ba3.png";